module.exports = __webpack_public_path__ + "static/media/gaming-active.eb1d812e.svg";